define(function(require) {
	const Marionette = require('backbone.marionette');
	const Radio = require('backbone.radio');
	const LoginChannel = Radio.channel('LoginChannel');
	const LoginModel = require('civicsModels/login_model');
	const tpl = require('./templates/t_itv_login_signin.hbs');
	const ViewManager = require('civicsUtils/view_manager');
	const AvailableFeatures = require('civicsUtils/available_features');

	return Marionette.LayoutView.extend({
		template: tpl,
		tagName: 'div',
		className: 'signin-holder',
		initialize: function(options) {
			this.config = options.config;
			this.model = new LoginModel();
			this.settings = LoginChannel.request('original:settings');
			LoginChannel.reply('signin:password', function() {
				return this.password;
			}, this);
			LoginChannel.reply('signin:settings', function() {
				return this.settings;
			}, this);
			LoginChannel.comply('signin:saveSettings', this.saveSettings.bind(this));
		},
		modelEvents: {
			change: 'render'
		},
		events: {
			'click @ui.button': 'openSSO',
		},
		ui: {
			button: '.login_button',
		},
		regions:{
		},
		saveSettings:function(settings){
		},
		onShow: function() {
		},
		openSSO: function(){
			this.globalConfig = ViewManager.globalConfig().toJSON();
			var loginRedirectConfig = this.globalConfig.loginRedirectPage;

			if( this.config.relayState ){
				App.sessionStorage.set('CIVICS', 'REDIRECT', this.config.relayState);
			} else if (AvailableFeatures.LoginRedirect()) {
				if (loginRedirectConfig && loginRedirectConfig.enabled) {
					//If current page is in the login redirect config
					//do not redirect to current page after login
					var pageIncludedInConfig = loginRedirectConfig.loginRedirectPages.find(function (e) {
						return window.location.href.indexOf(e.page) > 0
					});
					if (pageIncludedInConfig || window.location.pathname == '/' || this.config.disableRedirectOnOk) {
						App.sessionStorage.set('CIVICS', 'REDIRECT', this.config.loginRedirectPage);
					} else {
						App.sessionStorage.set('CIVICS', 'REDIRECT', window.location.href);
					}
				} else {
					App.sessionStorage.set('CIVICS', 'REDIRECT', this.config.loginRedirectPage);
				}
			} else {
				App.sessionStorage.set('CIVICS', 'REDIRECT', this.config.loginRedirectPage);
			}
			//Save Activation code
			if (this.config.urlParms && this.config.urlParms.activationCode){
				App.sessionStorage.set('CIVICS', 'ACTIVATION_CODE', this.config.urlParms.activationCode);
			}
			else {
				App.sessionStorage.remove('CIVICS', 'ACTIVATION_CODE');
			}

			// Check for ssoURL and redirect the user if it is available
			if (this.options.config.ssoURL) {
				window.location.assign(this.options.config.ssoURL);
				return false;
			}
		},
		getSSOContent: function(){
			//TODO - sanitize content
			return this.config.mySSOContent;
		},
		templateHelpers: function() {
			return {
				ssoContent: this.getSSOContent()
			};
		}
	});
});
